import loadingJson from '@/assets/video/lottie/loading-rocket.json';
import LottieWrapper from '@/components/ui/custom/LottieWrapper';
import { twMerge } from 'tailwind-merge';

type LoadingViewProps = {
  className?: string;
  classNameContainer?: string;
};

export default function LoadingView({
  className,
  classNameContainer,
}: LoadingViewProps) {
  return (
    <div
      className={twMerge(
        'grow justify-center flex items-center h-screen',
        classNameContainer,
      )}
    >
      <LottieWrapper
        animationData={loadingJson}
        className={twMerge('w-48', className)}
        loop
        autoplay
      />
    </div>
  );
}
